import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { base_url, bucket_base_url } from "../../constants/constant";
import { Axios } from "../../utils/axiosMiddleware";
import { Col, Row, Spin } from "antd";
import { BlogCard } from "./blogCard";
import { imageCache } from "../../utils/constant";

export const BlogListing = () => {
  const { data: blogs, isLoading } = useQuery({
    queryFn: () => Axios.get(`${base_url}blogs`),
    select: (res) => res?.data?.records,
  });

  // Preload every blog card image into the cache immediately when data arrives
  useEffect(() => {
    if (!blogs) return;
    blogs.forEach((item) => {
      const raw = item?.file?.[0]?.filePath;
      if (!raw) return;
      const url = raw.includes("http") ? raw : `${bucket_base_url}${raw}`;
      if (!imageCache.has(url)) {
        const img = new window.Image();
        img.src = url;
        img.onload = () => imageCache.set(url, true);
        img.onerror = () => imageCache.set(url, true);
      }
    });
  }, [blogs]);

  return (
    <Spin spinning={!!isLoading} style={{ marginTop: "90px" }}>
      <Row
        gutter={[16, 24]}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "70px",
          marginBottom: "50px",
          padding: "0 15px",
          minHeight: "60vh",
        }}
      >
        {blogs?.map((item) => {
          return (
            <Col
              xs={24}
              sm={12}
              md={10}
              lg={7}
              xl={7}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BlogCard item={item} />
            </Col>
          );
        })}
      </Row>
    </Spin>
  );
};